import { useEffect, useState } from "react";
import { checkForOverride } from "../helpers/theme";
import moment from "moment";

export default function BigTimeInternals({
	cue,
	cloud = false,
	time,
	baseTheme,
	baseThemeId,
}) {
	const [t, setT] = useState();

	const caclulateDifference = (min, max) => {
		if (cue.type === "big_time_to_tod") {
			return (time / (cue.endTimestamp - cue.timestamp)) * (min - max) + max;
		}
		// else if (cue.type === "big_time_countup") {
		// 	const calc = cue.duration - time;
		// 	console.log(calc);
		// 	return calc;
		// 	return (time / (cue.duration - cue.timestamp)) * (min - max) + max;
		// }
		return (time / parseInt(cue.duration)) * (min - max) + max;
	};

	useEffect(() => {
		let total = -630;
		setT(total - (time / parseInt(cue.duration)) * total);
		// console.log(t);
	}, [cue.duration, time]);

	return (
		<div className="flex justify-center items-center w-screen h-screen">
			<div className="flex justify-center item-center relative w-screen h-screen">
				<div
					className={`
				${baseThemeId}_${cue.type} ${cue.type}
				w-12/12 h-12/12 flex items-center justify-center`}
				>
					{cue.shape === "circle" && (
						<svg
							style={{
								width: "100vw",
								height: "100vh",
							}}
							className={`transform -rotate-90 transition-all duration-0`}
						>
							<circle
								opacity="10%"
								cx="48vw"
								cy="50vh"
								r="20vw"
								stroke={checkForOverride(
									baseTheme,
									cue.preset,
									cue.type,
									"background",
									"colour"
								)}
								strokeWidth={`${baseTheme?.["big_time"]?.thickness || 3}vw`}
								fill="none"
								className={`${cue.type}_line_key `}
							/>
							<circle
								style={{
									transitionDuration: cue.status === "onair" ? "0.1s" : "0s",
									transitionTimingFunction: "linear",
								}}
								cx="48vw"
								cy="50vh"
								r="20vw"
								stroke={checkForOverride(
									baseTheme,
									cue.preset,
									cue.type,
									"background",
									"colour"
								)}
								strokeWidth={`${baseTheme?.["big_time"]?.thickness || 3}vw`}
								strokeDasharray="130vw"
								strokeDashoffset={`${caclulateDifference(0, 135)}vw`}
								strokeLinecap={
									baseTheme?.["big_time"]?.roundedStyle === "butt"
										? "butt"
										: "round"
								}
								fill="none"
								className={`${cue.type}_line_key ${
									baseTheme?.["big_time"]?.elapsedStyle === "seconds"
										? "circle-timer-seconds"
										: ""
								}`}
							/>
						</svg>
					)}
					{cue.shape === "line" && (
						<svg
							style={{
								width: "100vw",
								height: "100vh",
							}}
							className="transform origin-center transition-transform duration-0"
						>
							<line
								opacity="10%"
								x1="35vw"
								x2="65vw"
								y1="66vh"
								y2="66vh"
								strokeWidth={`${baseTheme?.["big_time"]?.thickness || 2}vw`}
								stroke={checkForOverride(
									baseTheme,
									cue.preset,
									cue.type,
									"background",
									"colour"
								)}
								strokeLinecap={
									baseTheme?.["big_time"]?.roundedStyle === "butt"
										? "butt"
										: "round"
								}
								className={`${cue.type}_line_key`}
							/>
							<line
								style={{
									transitionDuration: cue.status === "onair" ? "0.1s" : "0s",
									transitionTimingFunction: "linear",
								}}
								x1="35vw"
								x2="65vw"
								y1="66vh"
								y2="66vh"
								strokeWidth={`${baseTheme?.["big_time"]?.thickness || 2}vw`}
								stroke={checkForOverride(
									baseTheme,
									cue.preset,
									cue.type,
									"background",
									"colour"
								)}
								strokeDasharray="30vw"
								strokeDashoffset={`${caclulateDifference(0, 30)}vw`}
								strokeLinecap={
									baseTheme?.["big_time"]?.roundedStyle === "butt"
										? "butt"
										: "round"
								}
								className={`${cue.type}_line_key ${
									baseTheme?.["big_time"]?.elapsedStyle === "seconds"
										? "line-timer-seconds"
										: ""
								}`}
							/>
						</svg>
					)}
					{cue.shape === "mask" && (
						<svg
							style={{
								width: "100vw",
								height: "100vh",
							}}
							className="transform origin-center transition-all duration-0"
						>
							<line
								opacity="10%"
								x1="33vw"
								x2="67vw"
								y1="53.5vh"
								y2="53.5vh"
								strokeWidth="12vw"
								stroke={checkForOverride(
									baseTheme,
									cue.preset,
									cue.type,
									"background",
									"colour"
								)}
								strokeLinecap={
									baseTheme?.["big_time"]?.roundedStyle === "butt"
										? "butt"
										: "round"
								}
								className={`${cue.type}_line_key ${
									baseTheme?.["big_time"]?.elapsedStyle === "seconds"
										? "mask-timer-seconds"
										: ""
								}`}
							/>
							<line
								style={{
									transitionDuration: cue.status === "onair" ? "0.1s" : "0s",
									transitionTimingFunction: "linear",
								}}
								// opacity="50%"
								x1="33vw"
								x2="67vw"
								y1="53.5vh"
								y2="53.5vh"
								strokeWidth="12vw"
								stroke={checkForOverride(
									baseTheme,
									cue.preset,
									cue.type,
									"background",
									"colour"
								)}
								strokeDasharray="34vw"
								strokeDashoffset={`${caclulateDifference(0, 35.4)}vw`}
								strokeLinecap={
									baseTheme?.["big_time"]?.roundedStyle === "butt"
										? "butt"
										: "round"
								}
								className={`${cue.type}_line_key ${
									baseTheme?.["big_time"]?.elapsedStyle === "seconds"
										? "mask-timer-seconds"
										: ""
								}`}
							/>
						</svg>
					)}
				</div>

				<span
					style={{
						color: checkForOverride(
							baseTheme,
							cue.preset,
							cue.type,
							"h1",
							"colour"
						),
						fontSize: "10vw",
						fontFamily: baseTheme.h1?.font || baseTheme.font?.family,
					}}
					className={`${baseThemeId}_${cue.type}_large_text ${cue.type}_large_text ${cue.type}_text_key absolute text-gray-600 font-bold -translate-y-1/4  left-0 right-0 text-6xl text-center top-1/2 transform`}
				>
					{/* <TimeContents cue={cue} skip={true} /> */}
					{moment
						.duration(time, "milliseconds")
						.format(cue.format || "HH:mm:ss", { trim: cue.trim })}
				</span>
				{cue.shape === "mask" && (
					<span
						style={{
							color: "#f1f1f1",
							clipPath: `inset(0vw ${caclulateDifference(33, 67)}vw 0 0)`,
							fontSize: "10vw",
							fontFamily: checkForOverride(
								baseTheme,
								cue.preset,
								cue.type,
								"font",
								"family"
							),
							mixBlendMode: "screen",
							transitionDuration: cue.status === "onair" ? "0.1s" : "0s",
							transitionTimingFunction: "linear",
						}}
						className={`absolute transition-tranform text-gray-600 font-bold -translate-y-1/4  left-0 right-0 text-6xl text-center top-1/2 transform
						`}
					>
						{/* <TimeContents cue={cue} skip={true} /> */}
						{moment
							.duration(time, "milliseconds")
							.format(cue.format || "HH:mm:ss", { trim: cue.trim })}
					</span>
				)}
			</div>
		</div>
	);
}
